import * as Yup from "yup";

const FormControl = [
  {
    size: { xs: 12, sm: 6 },
    props: { id: "grp_code", label: "社代碼 *", type: "text" },
  },
  {
    size: { xs: 12, sm: 6 },
    props: { id: "display_pos", label: "顯示次序 *", type: "number" },
  },
  {
    size: { xs: 12, sm: 6 },
    props: { id: "name_zh", label: "中文名稱 *", type: "text" },
  },
  {
    size: { xs: 12, sm: 6 },
    props: { id: "name_en", label: "English Name", type: "text" },
  },
];

const Schema = Yup.object().shape({
  grp_code: Yup.string()
    .trim()
    .required("請輸入社代碼")
    .max(50, "最多 50 字")
    .test("no-slash", "不可包含 /", (value) => !value || value.indexOf("/") === -1),
  name_zh: Yup.string()
    .trim()
    .required("請輸入中文名稱")
    .max(50, "最多 50 字")
    .test("no-slash", "不可包含 /", (value) => !value || value.indexOf("/") === -1),
  name_en: Yup.string()
    .trim()
    .max(50, "最多 50 字")
    .test("no-slash", "不可包含 /", (value) => !value || value.indexOf("/") === -1),
  display_pos: Yup.number()
    .typeError("請輸入數字")
    .integer("請輸入整數")
    .required("請輸入顯示次序"),
});

const FormikInstance = {
  initialValues: {
    grp_code: "",
    name_zh: "",
    name_en: "",
    display_pos: 0,
  },
  validateOnMount: true,
  validationSchema: Schema,
};

const FormContent = {
  Schema,
  FormControl,
  FormikInstance,
};

export default FormContent;
